/* eslint-disable react-hooks/exhaustive-deps */
// -- == //
import { useParams } from 'react-router';
import { useEffect, useRef } from 'react';
import SurveyCreateQuestions from '../lib/questions';
import Gap from 'components/gap';
// import { useTypedSelector } from "common/hooks/useTypedSelector";
// import AppLoading from "components/appLoading";
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import SurveyCreateFormInfo from '../lib/info';
import { useActions } from 'common/hooks/useActions';
import AppLoading from 'components/appLoading';
import PrimaryButton from 'components/form/buttons/primaryButton';

import * as S from './styles';

export default function SurveyDetailPage() {
  const { surveyDetail, questions } = useTypedSelector((state) => state.Survey);
  const { surveyDetailRequestAction, surveyQuestionListAction } = useActions();

  const formRef = useRef<{ submitForm: () => void } | null>(null);

  const params: any = useParams();

  useEffect(() => {
    if (params?.id) surveyDetailRequestAction(params?.id);
  }, []);

  useEffect(() => {
    if (surveyDetail?.data?.questions?.length) {
      surveyQuestionListAction(surveyDetail?.data?.questions);
    }
  }, [surveyDetail?.data?.questions?.length]);

  const transformSurveyData = (response: any) => {
    const questionTypeTitles: Record<string, string> = {
      descriptive: 'Open end',
      optional: 'Multiple',
      rate: 'Rating'
    };

    return response.data.questions?.map((question: any) => ({
      id: question.id,
      index: question.index,
      rate: question.rate,
      type: question.type,
      typeTitle: questionTypeTitles[question.type as keyof typeof questionTypeTitles] || question.type,
      translations: question.questionTranslations.map((qt: any) => ({
        language: qt.language,
        title: qt.title
      })),
      options: question.questionOptions.map((option: any) => ({
        id: option.id,
        translations: option.questionOptionTranslations.map((ot: any) => ({
          language: ot.language,
          title: ot.title
        }))
      }))
    }));
  };

  return (
    <S.Container>
      <S.Head>
        <S.Title>Survey</S.Title>
      </S.Head>
      <Gap size="20px" />
      <S.Div className="row">
        <S.Div className="col-md-12">
          <SurveyCreateFormInfo ref={formRef} data={surveyDetail.data} questions={transformSurveyData(surveyDetail)} />
        </S.Div>
        <S.Div className="col-md-12">
          <SurveyCreateQuestions
            data={surveyDetail.data}
            questions={transformSurveyData(surveyDetail)}
            isUpdate={true}
          />
        </S.Div>

        <div>
          <PrimaryButton
            onClick={() => formRef.current?.submitForm()}
            style={{ borderRadius: 10, marginRight: 'auto' }}
          >
            Edit Survey
          </PrimaryButton>
        </div>
      </S.Div>

      <AppLoading loading={surveyDetail.loading} />
    </S.Container>
  );
}
